import { createSlice } from "@reduxjs/toolkit";
import moveToExtraStorage from '@custom/rtk-apis/microscopy/switchPathologyStudyStorage';

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const switchPathologyStudyStorageSlice = createSlice({
  name: "switchPathologyStudyStorageSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(moveToExtraStorage.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(moveToExtraStorage.fulfilled, (state, { payload }) => {
        console.log("Fulfilled ",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.error=''
      })
      .addCase(moveToExtraStorage.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
      });
  },
});

export default switchPathologyStudyStorageSlice.reducer;
